var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.598 7.2a3.6 3.6 0 1 0-7.201 0 3.6 3.6 0 0 0 7.2 0m-8.4 0a4.8 4.8 0 1 1 9.6 0 4.8 4.8 0 0 1-9.6 0M5.22 20.4h13.55L17.112 15H6.883zm.777-6.6h12l2.032 6.6.368 1.2h-16.8l.367-1.2z"
  })));
};
export default SvgUser;